import { Injectable, Query } from '@angular/core';
import { Observable, of } from 'rxjs';
import { first, map, distinctUntilChanged, switchMap, take } from 'rxjs/operators';
import { AuthService } from './auth/auth.service';
import { AngularFirestoreCollectionGroup, AngularFirestore } from '@angular/fire/firestore';
import { AngularFireStorage } from '@angular/fire/storage';
import { UserModel } from '../models/user.model';
import { firestore } from 'firebase';



@Injectable({
  providedIn: 'root'
})
export class UserService {

  public userG;
  constructor(
    private authService: AuthService,
    private db: AngularFirestore,
    private storage: AngularFireStorage
  ) {
    this.user.subscribe(user => this.userG=user);
  }

  get user(): Observable<any> {
    // TODO ESTO SE DEBE MODIFICAR URGENTE SE LLAMA TDOD EL TIEMPO
    
    return this.authService.authState$.pipe(
      switchMap(user => {
        // console.log("--->Atencion User....>")
        // console.log(user);
        // console.log("------");
        return !user
               ? [{
                  id: null,
                  photoURL: './assets/images/blank-profile.png',
                  displayName: 'Unknow User'
                 }]
               : this.db
                  .collection('users', ref => ref.where('uid', '==', user.uid))
                  .valueChanges({ idField: 'id' }) // Coloca los valores con el id
                  .pipe(map(arr => arr[0])) // Sacamos el primer valor que es el que nos interesa
                  //TODO debemos usar el take 1 para que se desconecte
      })
    );
  }

  setUser(data, image?, type?){  
    data.updatedAt = firestore.FieldValue.serverTimestamp();
    return Promise.resolve()
      .then(() => {
        if (image) {
          return this.uploadImage(`users/${data.id}/`, image, 'profile', type)
            .then(path => console.log("User Photo Uploaded:", path)) //data.photoURL = path
            .catch(console.error);
        } else return null;
      })
      .then(() => this.db.collection('users').doc(data.id).update(data));
  }

  createUser(data) {
    data.createdAt = firestore.FieldValue.serverTimestamp()    
    data.updatedAt = firestore.FieldValue.serverTimestamp()   
    data.disabled = !!data.disabled; // XA: 17/sept/20
    console.log(data); 
    return this.db.collection('users').add(data);
  }

  uploadImage(path, image, name, type?){
    return this.storage.ref(`${path}${name}.${type}`)
    .putString(image, 'data_url', {contentType: `image/${type}`})
    .then(res =>  res.ref.getDownloadURL());
  }

  /** upsertUserLogin
   * Verifica si ya existe por el uid
   * Si existe actualiza ciertos valores
   * Si no existe agrega el usuario a Users
   */
  upsertUserLogin(data) {
    console.log(data); 
    data.updatedAt = firestore.FieldValue.serverTimestamp();     
    return this.db.collection('users', ref => ref.where('uid', '==', data.uid).limit(1))
      .valueChanges({ idField: 'id' })
      .pipe(first(), map(arr => arr[0]))
      .toPromise()
      .then(user => {
        if (!user) {
          data.createdAt = firestore.FieldValue.serverTimestamp();
          data.disabled = !!data.disabled; // XA: 17/sept/2020
          this.db.collection('users').add({...data});
        } else {
          const uData: any = {};
          if (data.phoneNumber) { uData.phoneNumber = data.phoneNumber; }
          uData.emailVerified = data.emailVerified;
          data.disabled = !!data.disabled; // XA: 17/sept/20
          this.db.collection('users').doc(user.id).update(uData);
        }
      });
  }

  doSignup(value){
    const {email, password, ...data} = value;
    return this.authService.doRegister({email, password})
      .then(user => {
        return this.createUser({...user, ...data});
      })
      .catch();
  }

  doSignupGoogle() {
    //return this.authService.goPopupLogin('google.com')
    return this.authService.doLogin('google.com')
      .then(user => {
        return this.upsertUserLogin( user );
      })
      .catch();
  }

  doSignupFacebook() {
    //return this.authService.goPopupLogin('facebook.com')
    return this.authService.doLogin('facebook.com')
      .then(user => {
        return this.upsertUserLogin( user );
      })
      .catch();
  }

  getInbox(limit:number=200){
    return this.db.collection('users').doc(this.userG.id).collection<any>('inbox', ref=> ref.where('spam', '==', false).orderBy('createdAt', 'desc').limit(limit))
    .snapshotChanges().pipe(
      map(actions => actions.map(a => {
        const data = a.payload.doc.data();// as Incidence; Inbox
        const id = a.payload.doc.id;
        return {id,  ...data };
      }))
    )
  }
  
  updateInbox(data){
    const id = data.id;
    delete data.id;
    this.db.collection('users').doc(this.userG.id).collection('inbox').doc(id).update(data);
  }

  getMessage(id){
    return this.db.collection('users').doc(this.userG.id).collection('inbox').doc(id).valueChanges()
    .pipe(
      take(1)
    )
    .toPromise()
  }
  setToken(data){
    return this.db.collection('users').doc(this.userG.id).collection('tokens').add({...data});
  }
}

